import { render, staticRenderFns } from "./pi-statistics-echarts.vue?vue&type=template&id=5ab9e531&"
import script from "./pi-statistics-echarts.vue?vue&type=script&lang=ts&"
export * from "./pi-statistics-echarts.vue?vue&type=script&lang=ts&"
import style0 from "./pi-statistics-echarts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports